import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HorizontalDivider = styled.div`
  width: 100%;
  height: 2px;
  background-color: var(--border-soft);
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '700px',
        borderRadius: '8px',
      },
    },
  ],
})``;
